var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstaIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(824 10704.371)",
    fill: "#2867b2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "b",
    cx: 0.291,
    cy: 0.998,
    r: 1.01,
    gradientTransform: "translate(0.001)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd676"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#f2a454"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.379,
    stopColor: "#f05c3c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#c22f86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.957,
    stopColor: "#6665ad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.985,
    stopColor: "#5c6cb2"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-824 -10704.371)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(824 10704.372)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M546.556,74.445a.694.694,0,0,1-.687.694h-1.785a.694.694,0,0,1-.687-.694V72.674a.694.694,0,0,1,.687-.694h1.785a.694.694,0,0,1,.687.694Z",
    transform: "translate(-532.207 -59.676)",
    fill: "url(#b)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2.122,
    height: 2.185,
    rx: 1.061,
    transform: "translate(11.708 12.795)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.146,
    cy: 0.146,
    r: 0.146,
    transform: "translate(13.265 13.094)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M573.46,95.412a6.557,6.557,0,0,1-6.544,6.572H549.937a6.556,6.556,0,0,1-6.544-6.572V78.557a6.556,6.556,0,0,1,6.544-6.572h16.982a6.556,6.556,0,0,1,6.543,6.572Z",
    transform: "translate(-543.393 -71.985)",
    fill: "url(#b)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.836 4.567)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M610.464,141.43h-8.117a6.147,6.147,0,0,1-6.138-6.138v-8.658a6.147,6.147,0,0,1,6.138-6.134h8.115a6.147,6.147,0,0,1,6.138,6.138V135.3a6.147,6.147,0,0,1-6.136,6.134Zm-8.117-18.718a3.926,3.926,0,0,0-3.921,3.921v8.658a3.926,3.926,0,0,0,3.921,3.921h8.115a3.926,3.926,0,0,0,3.921-3.921v-8.658a3.926,3.926,0,0,0-3.921-3.921Z",
    transform: "translate(-596.209 -120.5)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.381 4.617)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M671.3,205.234a5.823,5.823,0,0,1-5.817-5.817,5.91,5.91,0,0,1,1.785-4.217,5.567,5.567,0,0,1,4.074-1.6,5.993,5.993,0,0,1,4.326,1.771,5.634,5.634,0,0,1,1.451,4.075h0a5.949,5.949,0,0,1-1.719,4.079A5.73,5.73,0,0,1,671.3,205.234Zm-.123-8.923a2.891,2.891,0,0,0-2.024.836,3.187,3.187,0,0,0-.96,2.273,3.108,3.108,0,0,0,6.215-.03c.042-1.9-1.105-3.019-3.147-3.073Z",
    transform: "translate(-665.483 -193.598)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.442 3.666)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1.251,
    cy: 1.251,
    r: 1.251,
    transform: "translate(0 0)",
    fill: "#fff"
  }))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstaIcon);
export default __webpack_public_path__ + "static/media/insta-icon.f083677ab99d3d43d7f09106ae9a20b5.svg";
export { ForwardRef as ReactComponent };